import Container from "./container";

const ShopNow = () => {
  return (
    <Container>
      <div className=" flex justify-end">
        <a
          href="https://commalax.com/"
          className="py-3 px-8 text-sm rounded-full bg-black text-white"
        >
          Shop Now
        </a>
      </div>
    </Container>
  );
};
export default ShopNow;
